import React from 'react';

import SuiviDossier from 'components/SuiviDossier';
import { BorderedContentWithTitle } from 'components/WrappedComponents';

export const SuiviFourriere = (): React.ReactElement => {
  return (
    <BorderedContentWithTitle title="Suivi de mise en fourrière">
      <SuiviDossier />
    </BorderedContentWithTitle>
  );
};
